import { OperatorAccountInfoPage } from "./OperatorAccountPage";

const module = {
  routeProps: {
    path: "OperatorAccount",
    component: OperatorAccountInfoPage,
  },
  name: "Operator Account Info",
  label: "Operator Account Info",
  title: "Operator Account Info",
  showOnMenu: true,
};
export default module;
